import { createApiRef } from '@backstage/core-plugin-api';
import { NotFoundError, ResponseError } from '@backstage/errors';

const vaultApiRef = createApiRef({
  id: "plugin.vault.service"
});
class VaultClient {
  discoveryApi;
  fetchApi;
  constructor({
    discoveryApi,
    fetchApi
  }) {
    this.discoveryApi = discoveryApi;
    this.fetchApi = fetchApi;
  }
  async callApi(path, query) {
    const apiUrl = `${await this.discoveryApi.getBaseUrl("vault")}`;
    const response = await this.fetchApi.fetch(
      `${apiUrl}/${path}?${new URLSearchParams(query).toString()}`,
      {
        headers: {
          Accept: "application/json"
        }
      }
    );
    if (response.ok) {
      return await response.json();
    } else if (response.status === 404) {
      throw new NotFoundError(`No secrets found in path '${path}'`);
    }
    throw await ResponseError.fromResponse(response);
  }
  async listSecrets(secretPath, options) {
    const query = {};
    const { secretEngine } = options || {};
    if (secretEngine) {
      query.engine = secretEngine;
    }
    const result = await this.callApi(
      `v1/secrets/${encodeURIComponent(secretPath)}`,
      query
    );
    return result.items;
  }
}

export { VaultClient, vaultApiRef };
//# sourceMappingURL=api.esm.js.map
